import { chaosMode } from './chaosMode.js';
import omitDeep from './omitDeep.js';
import { failover } from './failover.js';
import { refreshToken } from './refreshToken.js';
import { graphQLAware } from './graphQLAware.js';

var hasChaosMode = localStorage.getItem('CHAOS_MODE') === 'true';
var DefaultClient = function DefaultClient(instances, onLogout) {
  var withFailover = failover(instances);
  var withRefreshToken = refreshToken(onLogout);
  var withGraphQLAwareness = graphQLAware();
  var withChaosMode = chaosMode();
  var graphQLQuery = function graphQLQuery(action) {
    return function (context) {
      return context.instance[action](context.arguments);
    };
  };
  var composedQuery = hasChaosMode ? withFailover(withRefreshToken(withGraphQLAwareness(withChaosMode(graphQLQuery('query'))))) : withFailover(withRefreshToken(withGraphQLAwareness(graphQLQuery('query'))));
  var composedMutate = hasChaosMode ? withFailover(withRefreshToken(withGraphQLAwareness(withChaosMode(graphQLQuery('mutate'))))) : withFailover(withRefreshToken(withGraphQLAwareness(graphQLQuery('mutate'))));
  var query = function query(arg) {
    var myQuery = composedQuery;
    var context = {
      arguments: arg
    };
    return myQuery(context);
  };
  var mutate = function mutate(arg) {
    // We need to clean up __typename set by apollo in order to make the mutations go through.
    // Disabling __typename in apollo will affect the caching.
    var cleanedArg = omitDeep(arg, '__typename');
    var context = {
      arguments: cleanedArg
    };
    return composedMutate(context);
  };
  return {
    query: query,
    mutate: mutate
  };
};

export { DefaultClient as default };
